import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useTickets({
  enabled = true,
  page = 1,
  search = '',
  status = '',
}: {
  enabled?: boolean;
  page?: number;
  search?: string;
  status?: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['supportTicket', page, search, status], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'supportTicket',
        params: { page, search, status },
      });
      return res;
    },
    enabled,
  });
}
